import P from "prop-types";
import { useState, useEffect } from "react";

import * as S from "./styles";

import { Pesquisa } from "../Pesquisa";
import Button from "../../../Buttons/Button";

export function ListaDePesquisas({ pesquisas }) {
  const [qtdPesquisas, setQtdPesquisas] = useState(10);
  const [listaDePesquisas, setListaDePesquisas] = useState([]);

  function updateQtdDePesquisas() {
    setQtdPesquisas(qtdPesquisas + 10);
  }

  useEffect(() => {
    setListaDePesquisas(pesquisas.slice(0, qtdPesquisas));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qtdPesquisas, pesquisas]);

  return (
    <S.Container>
      {listaDePesquisas?.map((pesquisa, index) => (
        <Pesquisa key={index} pesquisa={pesquisa} />
      ))}
      {listaDePesquisas.length === 0 && <>Nenhuma pesquisa encontrada! :(</>}
      <S.Container2>
        <S.DashedLine />
        {qtdPesquisas < pesquisas.length ? (
          <Button
            onClick={() => {
              updateQtdDePesquisas();
            }}
          >
            + mais pesquisas
          </Button>
        ) : (
          <></>
        )}
      </S.Container2>
    </S.Container>
  );
}

ListaDePesquisas.propTypes = {
  pesquisas: P.arrayOf(
    P.shape({
      titulo: P.string.isRequired,
      categorias: P.arrayOf(P.string).isRequired,
      autores: P.arrayOf(P.string).isRequired,
      revista: P.string.isRequired,
      palavras_chave: P.string.isRequired,
      ano: P.number.isRequired,
      link: P.string.isRequired,
    })
  ),
};
